interface DescriptionWithTooltipProps {
    description: string;
    onClick?: () => void;
    containerClassName?: string;
    clampClassName?: string;
    textClassName?: string;
}

export function DescriptionWithTooltip({
    description,
    onClick,
    containerClassName = "",
    clampClassName = "line-clamp-2",
    textClassName = "text-gray-600",
}: DescriptionWithTooltipProps) {
    if (!description) {
        return null;
    }

    const stopPropagation = (e: React.MouseEvent | React.PointerEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div className={`group/description relative inline-block ${containerClassName}`}>
            <p className={`text-sm ${clampClassName}`}>
                {onClick ? (
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onClick();
                        }}
                        onPointerDown={stopPropagation}
                        onMouseDown={stopPropagation}
                        className={`hover:underline text-left ${textClassName}`}
                    >
                        {description}
                    </button>
                ) : (
                    <span className={textClassName}>{description}</span>
                )}
            </p>
            <span
                role="tooltip"
                className="pointer-events-none invisible absolute left-0 top-full z-20 mt-1 w-max max-w-full break-all whitespace-pre-wrap rounded border border-gray-300 bg-gray-200 px-2 py-1.5 text-xs text-gray-900 shadow-lg group-hover/description:visible"
            >
                {description}
            </span>
        </div>
    );
}
